<script setup lang="ts">
import { computed } from 'vue';
import { PortfolioElementMultiple } from '@sonarwatch/portfolio-core';
import PortfolioBodyElementBase from './PortfolioBodyElementBase.vue';
import BaseValue from '@/components/BaseValue.vue';
import BasePrice from '@/components/BasePrice.vue';
import BaseAssetFromAsset from '@/components/BaseAssetFromAsset.vue';
import BaseAmountFromAsset from '@/components/BaseAmountFromAsset.vue';
import { walletNftsPlatformId } from '@/constants';
import { useAppStore } from '@/store/app';

const appStore = useAppStore();
const props = defineProps<{
  element: PortfolioElementMultiple;
  owner?: string;
}>();
const walletNftsMax = 10;

const isWalletNfts = computed(() => {
  return props.element.platformId === walletNftsPlatformId;
});

const assets = computed(() => {
  let assets = props.element.data.assets;
  if (isWalletNfts.value) assets = assets.slice(0, walletNftsMax);
  return assets;
});

function onClickSeeMore() {
  appStore.portfolioTab = 'nfts';
  window.scrollTo(0, 0);
}
</script>

<template>
  <PortfolioBodyElementBase
    :label="element.label"
    :network-id="element.networkId"
    :owner="owner"
  >
    <template #header>
      <span>
        {{ element.name }}
      </span>
    </template>
    <template #default>
      <v-table hover>
        <thead>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-left">Balance</th>
            <th class="text-right">Price</th>
            <th class="text-right">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(asset, i) in assets" :key="i">
            <td class="text-left"><BaseAssetFromAsset :asset="asset" /></td>
            <td class="text-left">
              <BaseAmountFromAsset
                :asset="asset"
                :hide-label="asset.name ? false : true"
              />
            </td>
            <td class="text-right">
              <BasePrice :asset="asset" />
            </td>
            <td class="text-right">
              <BaseValue :value="asset.value" />
            </td>
          </tr>
          <tr
            v-if="isWalletNfts && assets.length === walletNftsMax"
            @click="true"
          >
            <th class="text-center" colspan="4">
              <v-btn
                @click="onClickSeeMore"
                size="small"
                color="primary"
                variant="text"
                class="mt-2"
              >
                See more
              </v-btn>
            </th>
          </tr>
        </tbody>
      </v-table>
    </template>
  </PortfolioBodyElementBase>
</template>
